import { MEDICAL_PROFILE_GENERAL_TEMPLATE_CODE } from '../../../common/medicalProfile/medicalProfileTemplateCodes';

import { SectionSummary } from './SectionSummary.types';

// TODO DREGAB-29796: remove this file together with the mock delegation in sectionSummaryLookup.ts once the backend is ready
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const buildMockSectionSummaries = (patientId: number): SectionSummary[] => [
   {
      templateCode: MEDICAL_PROFILE_GENERAL_TEMPLATE_CODE,
      sectionId: 1,
      shortName: 'Alergie',
      count: 2,
      valuesSummary: 'Pokarmowa, Lekowa',
      fullTitle: 'Alergie',
      lastUpdate: { relative: '2 dni temu', absolute: new Date('2024-01-10'), author: 'dr Jan Kowalski' },
   },
   {
      templateCode: MEDICAL_PROFILE_GENERAL_TEMPLATE_CODE,
      sectionId: 29,
      shortName: 'Sytuacja społeczna',
      count: 1,
      valuesSummary: 'Mieszka z rodziną',
      fullTitle: 'Sytuacja społeczna',
      lastUpdate: { relative: 'wczoraj', absolute: new Date('2024-01-11'), author: 'dr Anna Nowak' },
   },
];
